(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["how-to-use-faq"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.faq-box').forEach(box => {
  box.addEventListener('click', () => {
    let ans = box.querySelector('.faq-answer');
    ans.style.display = ans.style.display === "block" ? "none" : "block";
  });
});

  } catch(e) { console.error(e); }
})();
})();
